export const API_ADDRESS = 'https://api.sinatraology.com/web/api';
// export const API_ADDRESS = 'http://localhost:8080/web/api';
export const PAGE_TITLE_BASE = "Sinatraology - The Ultimate Frank Sinatra Discography";
